import React, { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        if (token) {
            localStorage.setItem('token', token);
            try {
                const decodedToken = jwtDecode(token);
                setUserRole(decodedToken.role);
            } catch (error) {
                console.error('Error decoding token:', error);
                setToken(null);
                setUserRole(null);
            }
        } else {
            localStorage.removeItem('token');
            setUserRole(null);
        }
    }, [token]);

    const login = (newToken) => {
        console.log('Login function called with token:', newToken);
        setToken(newToken);
    };

    const logout = () => {
        setToken(null);
    };

    return (
        <AuthContext.Provider value={{ token, login, logout, userRole }}>
            {children}
        </AuthContext.Provider>
    );
};
